import styled from 'styled-components';

export const ErrorMessage = styled.div`
  margin: 0.5rem 0;
  font-size: 1rem;
  color: red;
`;

export const NameWrapper = styled.div`
  font-size: 1.5rem;
  margin: 0.25rem;
  display: flex;
  justify-content: start;
  flex-direction: column;
  input {
    font-size: inherit;
    margin-left: 0.25rem;
  }
`;
export const InputWrapper = styled.div`
  font-size: 1.5rem;
  margin: 1rem 0.25rem;
  display: flex;
  justify-content: start;
  flex-direction: column;
  input {
    font-size: inherit;
    margin-left: 0.25rem;
  }
`;
export const FlexRow = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  margin-left: 1rem;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: 2rem;
  position: relative;
`;

export const Button = styled.button`
  border-radius: 5px;
  background: lightblue;
  border: 1px solid #5c9db2;
  font-weight: 500;
  color: white;
  height: 1.5rem;
  min-width: 5rem;
  height: 2rem;
  font-size: 1rem;
  &:disabled {
    background-color: lightgray;
  }
`;

export const PlayerListItem = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0.5rem;
  border-top: 1px solid black;
  font-size: 1.5rem;
`;
